<template>
  <div class="container">
    <ValidationObserver v-slot="{handleSubmit}">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider>
          <label>
            <input
              v-model="form.number"
              type="text"
            >
          </label>
        </ValidationProvider>

        <b-button
          variant="primary"
          class="float-end ms-3"
          type="submit"
          :disabled="db"
        >
          Submit
        </b-button>

        <b-button
          variant="warning"
          class="float-end"
          @click="onClose"
        >
          {{$t('modal.button.back')}}
        </b-button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
  export default {
    name: "Payment-PostModal",
    data() {
      return {
        form: {
          number: null,
        },
        db: false,
      }
    },

    methods: {
      onClose() {
        this.$emit('onClose')
      },
      onSubmit() {

      }
    }
  }
</script>